var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"custom-arrow rounded-circle d-flex align-items-center justify-content-center",domProps:{"innerHTML":_vm._s(require('~/assets/mlearn/icons/slider/left.svg?raw'))}})
}
var staticRenderFns = []

export { render, staticRenderFns }